import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { CurrentDistrictWarehousesSelectorViewModel } from "../warehouseManipulation/warehouseManipulation-viewModel";
import { warehouseLocation, WarehouseLocationManipulationViewModel } from "./warehouseLocationManipulation-viewModel"

export class WarehouseLocationManipulationView extends View<WarehouseLocationManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-87492327-9EA3-4AD0-A947-C5B06BD79DE4"
    }
    loadHtml(): string {
        let element = require('./warehouseLocationManipulation.html').default;
        let style = require('./warehouseLocationManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    public set warehouseSelector(v: CurrentDistrictWarehousesSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): CurrentDistrictWarehousesSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: CurrentDistrictWarehousesSelectorViewModel;
    public set warehouseLocation(v: ObservableArray<warehouseLocation>) { this._warehouseLocation = v; } public get warehouseLocation(): ObservableArray<warehouseLocation> { return this._warehouseLocation;} private _warehouseLocation: ObservableArray<warehouseLocation>;
    
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    requestWarehouseLocationCreation(){
        this.dataContext.requestWarehouseLocationCreation();
    }
}
